<template>
  <div>
    <v-container>
      <v-layout row wrap justify-center>
        <v-flex sm12 class="text-xs-center">
          <h1>AR Members Directory</h1>
        </v-flex>
        <v-flex xs12>
          <a href="https://accessibleretail.co.uk/" target="_blank" title="Visit Website">
            <v-img :contain=true :height="dimension" :src="require('@/assets/ar-logo.svg')"></v-img>
          </a>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center mt-5>
        <v-flex sm12 v-if="!check" class="text-xs-center">
          <v-btn :to="{name: 'login'}" color="primary">
            Login
          </v-btn>
        </v-flex>
        <v-flex sm12 v-if="check" class="text-xs-center">
          <v-btn :to="{name: 'search'}" color="primary">
            Search
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center mt-5>
        <v-flex class="text-xs-center">
          <h1>App Sponsors</h1>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid grid-list-xl>
      <v-layout wrap align-center justify-center row>
      <v-flex v-for="sponsor in randomSponsors()" :key="sponsor.title">
        <a :href=sponsor.website target="_blank" :title="sponsor.title">
          <v-img :contain=true :height="dimension" :width="dimension" :src="sponsor.source" ></v-img>
        </a>
      </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Home',
  data: () => ({
    sponsors: [
      { title: 'Freeths', source: require('@/assets/sponsors/freeths-logo-with-bg.svg'), website: 'https://www.freeths.co.uk/' },
      { title: 'Quod', source: require('@/assets/sponsors/quod-logo.svg'), website: 'https://www.quod.com/' },
      { title: 'M7 Real Estate', source: require('@/assets/sponsors/m7-real-estate.svg'), website: 'https://www.m7re.eu/' },
      { title: 'Dentons', source: require('@/assets/sponsors/dentons-logo.svg'), website: 'https://www.dentons.com/en/' },
      { title: 'Pure Gym', source: require('@/assets/sponsors/puregym-logo.svg'), website: 'https://www.puregym.com/' }
    ]
  }),
  created () {
    this.setTitle({ title: null })
  },
  computed: {
    check () {
      return this.$store.state.auth.status.loggedIn
    },
    // binding () {
    //   const binding = {}
    //
    //   if (this.$vuetify.breakpoint.smAndDown) {
    //     binding.column = true
    //     binding.row = false
    //   } else {
    //     binding.column = false
    //     binding.row = true
    //   }
    //   return binding
    // },
    dimension () {
      let dimension = 200

      if (this.$vuetify.breakpoint.smAndDown) {
        dimension = 100
      }
      return dimension
    }
  },
  methods: {
    ...mapActions(
      'application', {
        setTitle: 'setTitle'
      }
    ),
    randomSponsors () {
      return this.lodash.shuffle(this.sponsors)
    }
  }
}
</script>

<style scoped>
</style>
